import Joi from 'joi';

import {
  tenantContactCompanyNameRequired,
  tenantContactUpdateIdRule,
  tenantContactWriteFields,
} from '../../../../shared/modules/contacts/validators/schemas/tenant-contact-write-fields.schema';

/**
 * Schema for contact validation belonging to a supplier.
 */
export const updateSupplierContactSchema = () =>
  Joi.object({
    ...tenantContactUpdateIdRule(),
    ...tenantContactCompanyNameRequired(),
    ...tenantContactWriteFields(),
  }).unknown();
